// --- Core ---
import {useMemo, useState} from "react";
import {FormattedMessage} from "react-intl";
// --- Material UI ---
import {DatePicker} from "@mui/x-date-pickers";

const DateSelect = ({disabled, helperText, value, required, ...rest}) => {
  const [error, setError] = useState(null);

  const errorMessage = useMemo(() => {
    switch (error) {
      case 'disablePast':
        return (
          <FormattedMessage
            id="shared.input.date.disablePastMessage"
            defaultMessage="Date should not be in the past"
          />
        );
      case 'maxDate':
        return (
          <FormattedMessage
            id="shared.input.date.maxDateMessage"
            defaultMessage="Date should not be after to-date"
          />
        );
      case 'minDate':
        return (
          <FormattedMessage
            id="shared.input.date.minDateMessage"
            defaultMessage="Date should not be before from-date"
          />
        );
      case 'invalidDate':
        return (
          <FormattedMessage
            id="shared.input.date.invalidDateMessage"
            defaultMessage="Invalid Date Format"
          />
        );
      default:
        return null;
    }
  }, [error]);

  return (
    <DatePicker
      onError={setError}
      value={value || null}
      slotProps={
        {
          textField: {
            disabled: disabled,
            fullWidth: true,
            helperText: helperText || errorMessage,
            required: required,
            variant: "outlined"
          }
        }
      }
      {...rest}
    />
  );
};

export default DateSelect;
